import React from 'react';

// TruncateText Component
export const TruncateText = (props) => {
    const { text, limit } = props;

    if (!text) {
        return null;
    }

    const truncatedText = text.length > 50 ? text.substring(0, 450) + '...' : text;

    return <p>{truncatedText}</p>;
};

export const delay = async (ms) => {
    return new Promise((resolve) =>
        setTimeout(resolve, ms));
};

export const refreshPage = async () => {
    window.location.reload();
};

// Default export (if needed, optional)
const Generic = () => { };
export default Generic;





